import { Component, OnInit } from '@angular/core';
import { LocLabelModifier } from '../../components/clickable-row-table/models/data-table-config.models';
import {
  ValueButtonTable,
  ValueCheckboxTable,
  ValueDateTable,
  ValueIconButtonTable,
  ValueIconTable,
  ValueNumberTooltipTable,
  ValuePhoneNumberTable,
  ValueRentalUnitAdrTable,
  ValueResidentUserTable,
  ValueStringLocalizedTable
} from '../../components/clickable-row-table/models/value-table.model';
import { TemplateService } from './template.service';

/**
 * Used in root component to initialize TemplateService
 */
@Component({
  selector: 'app-template-service',
  templateUrl: './template-service.component.html',
  styleUrls: ['./template-service.component.scss']
})
export class TemplateServiceComponent implements OnInit {
  mod = LocLabelModifier;

  constructor(public templateService: TemplateService) {}

  ngOnInit(): void {}

  // #region defaultRowTable functions
  public isNumberTooltip(element: any): boolean {
    return element instanceof ValueNumberTooltipTable;
  }

  public isButton(element: any): boolean {
    return element instanceof ValueButtonTable;
  }

  public isIcon(element: any): boolean {
    return element instanceof ValueIconTable;
  }

  public isIconButton(element: any): boolean {
    return element instanceof ValueIconButtonTable;
  }

  public isDate(element: any): boolean {
    return element instanceof ValueDateTable;
  }

  public isLocalized(element: any): boolean {
    return element instanceof ValueStringLocalizedTable;
  }

  public isPhoneNumber(element: any): boolean {
    return element instanceof ValuePhoneNumberTable;
  }

  public isRentalUnitAdr(element: any): boolean {
    return element instanceof ValueRentalUnitAdrTable;
  }

  public isCheckbox(element: any): boolean {
    return element instanceof ValueCheckboxTable;
  }

  public isResidentUser(element: any): boolean {
    return element instanceof ValueResidentUserTable;
  }

  public isBasic(element: any): boolean {
    return (
      !this.isNumberTooltip(element) &&
      !this.isButton(element) &&
      !this.isIcon(element) &&
      !this.isDate(element) &&
      !this.isLocalized(element) &&
      !this.isPhoneNumber(element) &&
      !this.isRentalUnitAdr(element) &&
      !this.isCheckbox(element) &&
      !this.isIconButton(element) &&
      !this.isResidentUser(element)
    );
  }
  // #endregion
}
